import { render } from "./BenchmarkDetails.vue?vue&type=template&id=9bd3d392&scoped=true"
import script from "./BenchmarkDetails.vue?vue&type=script&lang=js"
export * from "./BenchmarkDetails.vue?vue&type=script&lang=js"

import "./BenchmarkDetails.vue?vue&type=style&index=0&id=9bd3d392&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd3d392"]])

export default __exports__